import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import axios from "axios";


//axios.defaults.baseURL =  "https://racedb.pesa.solutions/api/"; //prod
//https://deca.pesa.solutions
axios.defaults.baseURL = "https://decadb.pesa.solutions/api/";//not in use
//axios.defaults.baseURL = "http://localhost:3320/api/"; //dev
// Create an Axios instance for read operations

axios.defaults.withCredentials = true;

const el = document.getElementById('root');

const root = ReactDOM.createRoot(el);

root.render(<App/>);